import GSAP from 'gsap'
import Close from '../../../assets/icons/close.svg'
import Scroll from '../../components/Scroll'
export default class Apropos {
  constructor() {
    //setup
    this.menuLink = document.querySelector('.deskPoint')
    this.tl = new GSAP.timeline({ paused: true, reversed: true })

    //Method
    this.event()
    this.createPage()
    this.closePage()
  }

  event() {
    this.menuLink.addEventListener('click', this.togglePage.bind(this))
  }
  createPage() {
    //Page
    this.page = document.createElement('div')
    this.page.classList.add('apropos')
    document.body.appendChild(this.page)

    //Page Wrapper
    this.pageWrapper = document.createElement('div')
    this.pageWrapper.className = 'page_wrapper'
    this.pageWrapper.dataset.scroll = 'data-scroll'
    this.page.appendChild(this.pageWrapper)

    //Page content
    this.pageContent = document.createElement('div')
    this.pageContent.className = 'page_content'
    this.pageWrapper.appendChild(this.pageContent)

    //title
    this.pageTitle = document.createElement('h2')
    this.pageTitle.innerText = "Bonjour, je m'appelle Kellig, un peu comme ©Kellogg's, les céréales complètes ;)"
    this.pageContent.appendChild(this.pageTitle)

    //Texte
    this.pageDescription = document.createElement('p')
    this.pageDescription.innerHTML =
      "Passionné par l'Art, le Design et le Code, je ne m'arrête jamais d'apprendre de nouvelles choses. J'aime surtout créer, matérialiser mes idées avec différents outils et les voir se réaliser.<br/><br/>Mes objectifs sont d'accompagner les clients dans une démarche créative et ludique grâce à l'intelligence collective, considérer les usagers pour donner du sens au projet, co-concevoir des produits numériques avec une expèrience immersive.<br/><br/>Direction Artistique, UX & UI Design, Front-end, j'aime utiliser mon panel de savoir-faire avec la même efficacité. <br/> Le web est une jungle où il faut constamment s'adapter."
    this.pageContent.appendChild(this.pageDescription)

    //Close
    this.closeBtn = document.createElement('img')
    this.closeBtn.className = 'closePage'
    this.closeBtn.src = Close
    this.page.appendChild(this.closeBtn)
  }
  togglePage() {
    this.tl.clear()
    this.tl
      .to(this.page, {
        autoAlpha: 1,
        display: 'block',
        ease: 'Power1.easeOut',
        duration: 1,
      })
      .fromTo(
        this.pageTitle,
        {
          autoAlpha: 0,
          y: 10,
        },
        { autoAlpha: 1, y: 0, duration: 0.5 }
      )
      .fromTo(
        this.pageDescription,
        {
          autoAlpha: 0,
          y: 10,
        },
        { autoAlpha: 1, y: 0, duration: 0.5 }
      )

    if (!this.tl.isActive()) {
      this.tl.reversed() ? this.tl.play(0).timeScale(1) : this.tl.timeScale(2).reverse()
    }
  }
  closePage() {
    this.closeBtnAp = document.querySelector('.apropos .closePage')
    this.closeBtnAp.addEventListener('click', () => {
      if (!this.tl.isActive()) {
        this.tl.timeScale(2).reverse()
      }
    })
    this.page.addEventListener('click', () => {
      if (!this.tl.isActive()) {
        this.tl.timeScale(2).reverse()
      }
    })
  }
  update() {
    this.scroll = new Scroll()
  }
}
